import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Table, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import trash from "../../../Assets/Images/trash.png";
import Select from "react-select";
import "./PL.css";
import {
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import {
  getPriceLevel,
  updatePriceLevel,
  deletePriceLevel,
} from "../../../Helpers/apiCalls/Manage/PriceLevels";

import DeleteModal from "../../../Components/Modals/DeleteModal";
import InputError from "../../../Components/InputError/InputError";
import { validatePriceLevel } from "../../../Helpers/Validation/Manage/PriceLevelValidation";
import ReactLoading from "react-loading";

export default function ViewPriceLevel(props) {
  const { id } = useParams();

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);
  const [commissionRates, setCommissionRates] = useState({});
  const [priceLevel, setPriceLevel] = useState({});
  const [name, setName] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  const [storeData, setStoreData] = useState({});
  const [foodPandaData, setFoodPandaData] = useState({});
  const [grabFoodData, setGrabFoodData] = useState({});

  const [storeSet, setStoreSet] = useState([
    { title: "store", eventKey: "store", has_commission: false },
    { title: "foodpanda", eventKey: "foodpanda", has_commission: true },
    { title: "grabfood", eventKey: "grabfood", has_commission: true },
  ]); //preparation for future change

  async function del() {
    setIsClicked(true);
    const response = await deletePriceLevel(id);
    if (response.data) {
      toast.success("Successfully deleted price level!", {
        style: toastStyle(),
      });
      handleCloseDeleteModal();
      setTimeout(() => navigate("/pricelevels"), 1000);
    } else {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    }
  }

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
  });

  useEffect(() => {
    fetchPriceLevels();
  }, []);

  async function fetchPriceLevels() {
    const response = await getPriceLevel(id);
    if (response.data) {
        const data = response.data.data.data;
        setFetchedName(data);
        setFetchedCommissionRates(data);
        setFetchedPriceLevels(data);
    } else {
        toast.error("Error fetching price level", {
            style: toastStyle(),
        });
    }
  }

  function setFetchedName(data) {
    setName(data.name);
  }

  function setFetchedCommissionRates(data) {
    data.price_level_types.forEach((price_level_type) => {
      setCommissionRates((prev) => {
        var tmp = structuredClone(prev);
        tmp[price_level_type.name] = price_level_type.commission_rate;
        return { ...tmp };
      });
    });
  }

  function setFetchedPriceLevels(data) {
    var price_levels = {};
    data.price_level_types.forEach((price_level_type) => {
      price_levels[price_level_type.name] = price_level_type.categories;
    });
    setPriceLevel(price_levels);
  }


  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xl={6}>
            <h1 className="page-title mb-4">
              VIEW PRICE LEVEL
            </h1>
          </Col>
        </Row>
        <Row>
          <Col className="nc-modal-custom-row mt-0 mb-4" xs={5}>
            PRICE LEVEL NAME
            <Form.Control
              type="text"
              name="name"
              placeholder="Price Level Name"
              value={name}
              className="nc-modal-custom-input"
              disabled
            />
          </Col>
        </Row>
        <Tabs defaultActiveKey="store" id="PL-tabs">
          {storeSet.map((store) => {
            return (
              <Tab
                eventKey={store.eventKey}
                title={store.title}
                className="p-3"
              >
                {store.has_commission ? (
                  <Row className="mt-2 me-3 mb-5">
                    <Col xs={3}>INITIAL COMISSION RATE:</Col>
                    <Col
                      className="text-capitalize nc-modal-custom-row-green-not-bold"
                      xs={2}
                    >
                      <Form.Control
                        min={0}
                        type="number"
                        value={commissionRates[store.eventKey]}
                        defaultValue="0.00"
                        name={store.eventKey + " - COMMISSION RATES"}
                        className="nc-modal-custom-input-number"
                        disabled
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}

                <div className="product-tab">
                  {}
                  {Object.keys(priceLevel)?.length > 0 ? (
                    priceLevel[store.eventKey].map(
                      (product, product_index) => {
                        //   <Row className="nc-modal-custom-row-view mt-4 ms-2 mb-4">
                        return (
                          <Col className="me-3 product-container">
                            {product.name}
                            <Row className="container-wrapper align-left mt-3 me-3 mb-3">
                              {/* {} */}
                              {product.products.map(
                                (product_variant, product_variant_index) => {
                                  return (
                                    <Row className="mt-2 me-3 mb-2">
                                      <Col className="text-capitalize nc-modal-custom-row-green-not-bold ms-4">
                                        {product_variant.product}
                                      </Col>
                                      <Col>
                                        <Form.Control
                                          value={product_variant.price}
                                          className="nc-modal-custom-input-number"
                                          disabled
                                        />
                                      </Col>
                                    </Row>
                                  );
                                }
                              )}
                            </Row>
                          </Col>
                        );
                      }
                    )
                  ) : (
                    <Row className="nc-modal-custom-row-view mt-4 ms-2 mb-4">
                      No Data
                    </Row>
                  )}
                </div>
              </Tab>
            );
          })}
        </Tabs>
        <div className="d-flex justify-content-end mt-3">
          <button
            type="button"
            className="button-secondary me-3"
            onClick={() => navigate("/pricelevels")}
          >
            Cancel
          </button>
          {isClicked ? (
            <div className="button-warning-fill d-flex justify-content-center">
              <ReactLoading
                type="bubbles"
                color="#FFFFFF"
                height={50}
                width={50}
              />
            </div>
          ) : (
            <button
              type="button"
              className="button-warning-fill me-3 justify-content-center"
              onClick={handleShowDeleteModal}
            >
              Delete
            </button>
          )}
          <button
            type="button"
            className="button-tertiary me-3"
            onClick={() => {
              setTimeout(
                () =>
                  navigate("/pricelevels/edit/" + id),
                1000
              );
            }}
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
}
